import React from 'react';
import { CaseListingResultOrInfo } from 'app/area/case-report/case-listing/components/case-listing-result-or-info';
import { STATE } from 'app/constants';
import { useTranslation } from 'app/infrastructure/translate/hooks';
import { caseListingTranslation } from 'app/area/case-report/case-listing/constants';
import { HeaderVisibilityConfiguration } from 'app/components';
import { FavouriteDefinition, RenderMode } from 'app/types-shared';
import { PrimaryActionComponentFactory } from 'app/area/case-report/case-listing/types';
import { useCaseListingEvents, useSelectors, useLoadReportLayoutEffect } from 'app/area/case-report/case-listing/hooks';
import { useCaseListingException } from 'app/area/case-report/components/use-case-listing-exception';

import styles from './case-listing-tile-container.scss';
import { PortalProvider } from 'app/area/case-report/case-listing/portal-provider';

interface CaseListingProps {
  workingDefinition: FavouriteDefinition;
  report?: number;
}

export interface CaseListingExternalProps {
  headerVisibilityConfiguration?: HeaderVisibilityConfiguration;
  windowAsScrollableAncestor?: boolean;
  requestedRenderMode?: RenderMode;
  hideLoadResults?: boolean;
  hideNumberOfHits?: boolean;
  primaryActionComponentFactory?: PrimaryActionComponentFactory;
  autoExecute?: boolean;
}

export const CaseListing = ({
  workingDefinition,
  primaryActionComponentFactory,
  windowAsScrollableAncestor,
  headerVisibilityConfiguration,
  requestedRenderMode,
  autoExecute
}: CaseListingProps & CaseListingExternalProps) => {

  const translation = useTranslation(STATE.caseListing, caseListingTranslation);
  
  const {
    fetching,
    results,
    totalNumberOfResults,
    renderMode,
    errorsExecuteFailed
  } = useSelectors();

  const {
    fetchMoreData
  } = useCaseListingEvents(
    workingDefinition,
    primaryActionComponentFactory,
    requestedRenderMode,
    fetching,
    autoExecute,
    results,
    totalNumberOfResults
  );

  const ErrorHandlingComponent = useCaseListingException({
    autoExecute,
    errorsExecuteFailed,
    fetching,
    totalNumberOfResults,
    translation
  });

  if (ErrorHandlingComponent !== null) {
    return <div className={styles.infoWrapper}> {ErrorHandlingComponent} </div>;
  }

  // Load layout model for non-dashboard contexts
  useLoadReportLayoutEffect();

  return (<PortalProvider>
    <CaseListingResultOrInfo
      translation={translation}
      autoExecute={autoExecute}
      results={results}
      totalNumberOfResults={totalNumberOfResults}
      fetching={fetching}
      fetchMoreData={fetchMoreData}
      renderMode={renderMode}
      primaryActionComponentFactory={primaryActionComponentFactory}
      windowAsScrollableAncestor={windowAsScrollableAncestor}
      headerVisibilityConfiguration={headerVisibilityConfiguration} />
  </PortalProvider>);
};
